import Amafresp from './../assets/partnerBrands/amafresp.png'
import Cabesp from './../assets/partnerBrands/cabesp.svg'
import Sepaco from './../assets/partnerBrands/sepaco-ans-novo.svg'

export type partnerType = {
    [key: string]: {
        localLogo: string
        labName: string
    }
}

export const partnerTypes: partnerType = {
    1000: {
        localLogo: Amafresp,
        labName: 'Dra.Ama',
    },
    1001: {
        localLogo: Sepaco,
        labName: 'Sepaco',
    },
    1002: {
        localLogo: Cabesp,
        labName: 'Cabesp',
    },
}
